import { useMutation } from '@tanstack/react-query'
import { deleteVoucherAttachment } from '../service/voucherService'
import { showErrorMessage } from '../../../utils/message'

export const useDeleteVoucherAttachment = () => {
  return useMutation({
    mutationFn: deleteVoucherAttachment,
    onError: () => {
      showErrorMessage()
    }
  })
}

export type DeleteVoucherAttachmentMutation = ReturnType<typeof useDeleteVoucherAttachment>
